import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Moment from "react-moment";
import { addPostReply } from "../../../actions/post";
import EmployerCommentsReplyItem from "./EmployerCommentsReplyItem";

const EmployerCommentsItem = ({
  id,
  comment: {
    _id,
    avatar,
    text,
    companyname,
    firstname,
    lastname,
    replies,
    date,
  },
  addPostReply,
}) => {
  const [reply, setReply] = useState("");
  const [showReply, setShowReply] = useState(false);
  return (
    <Fragment>
      <div className="comment-alt">
        <div className="comment-user">
          <div className="comment-avi-container">
            <img
              src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
              className="comment-avi"
              alt="avatar"
            />
          </div>
          <div className="comment-user-info">
            <div className="comment-user-name blue">{companyname}</div>
            <div className="comment-user-job-title">
              <i className="far fa-address-card blue"></i>
              <span className="job-title">
                {firstname} {lastname}
              </span>
            </div>
          </div>
          <div className="comment-header-container">
            <div className="comment-date">
              <Moment format="MM/DD/YYYY">{date}</Moment>
            </div>
            <i className="fas fa-ellipsis-v fa-lg pt blue"></i>
            <div className="modal">
              <ul className="modal-items">
                <li className="modal-item">
                  <i className="fas fa-flag mx-5 white"></i>
                  Report
                </li>
                <li className="modal-item">
                  <i className="fas fa-ban mx-5 white"></i>
                  Block
                </li>
                <li className="modal-item">
                  <i className="fas fa-times mx-5 white"></i>
                  Delete
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="comment-footer">
          <div className="comment-text-container">
            <p className="post-text">{text}</p>
          </div>
          <div className="comment-action-buttons">
            <div className="comment-left-buttons">
              <i className="far fa-thumbs-up mx-5 blue"></i>
              <span className="white">78</span>
            </div>
            <div
              className="comment-right-buttons"
              onClick={(e) => setShowReply(true)}
            >
              <i className="fas fa-reply mx-5 blue"></i>
              <span className="white">Reply</span>
            </div>
          </div>
          <div className="reply-container">
            <form
              onSubmit={(e) => {
                e.preventDefault();
                addPostReply({ reply, _id, id });
                setReply("");
              }}
              className="comment-reply-input-container"
            >
              <div className="comment-avi-container">
                <div className="comment-avi"></div>
              </div>
              {showReply && (
                <div className="comment-reply-input-hidden">
                  <input
                    type="text"
                    className="comment-reply-input"
                    name="reply"
                    value={reply}
                    onChange={(e) => setReply(e.target.value)}
                    placeholder="Enter your reply here..."
                  />
                  <button className="comment-reply-input-button background-blue">
                    <i className="far fa-comments"></i>
                  </button>
                </div>
              )}
            </form>
            {replies.map((reply) => (
              <EmployerCommentsReplyItem key={reply._id} reply={reply} />
            ))}
            <div className="all-replies">
              <p className="replies">
                <i className="fas fa-reply-all mx-5 blue"></i>
                All Replies
              </p>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

EmployerCommentsItem.propTypes = {
  comments: PropTypes.array.isRequired,
  addPostReply: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  post: state.post,
});

export default connect(mapStateToProps, {
  addPostReply,
})(EmployerCommentsItem);
